<div *ngIf="displayChart">
  <app-display-eia-highchart
          [chartId]="'gasDisposition'"
          [inputChart]="_chartOptions">
  </app-display-eia-highchart>
</div>


// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/display-gas-trade-disposition/display-gas-trade-disposition.component.html